<template>
  <AuthLayout>
    <h1 class="auth-title">
      {{ $t('authentication.serviceRestricted') }}
    </h1>
    <div class="log-restricted fal fa-ban"></div>
    <span class="auth-subtitle">{{ $t('authentication.infoRetailer') }}</span>
  </AuthLayout>
</template>

<script>
  import AuthLayout from '../components/AuthLayout.vue'

  export default {
    name: 'Restricted',
    components: {AuthLayout},
  }
</script>

<style lang="scss" scoped>
  .log-restricted {
    margin: 2rem auto;
    font-size: 72px;
    color: #D0021B;
  }
</style>
